import { render, staticRenderFns } from "./SmsConsent.vue?vue&type=template&id=dba472f0"
import script from "./SmsConsent.vue?vue&type=script&lang=js"
export * from "./SmsConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports